import { render, staticRenderFns } from "./PdfLinkShow.vue?vue&type=template&id=154f12bf&"
import script from "./PdfLinkShow.vue?vue&type=script&lang=ts&"
export * from "./PdfLinkShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports